export const IDCart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.5 8.5H16.2M11.5 11.5H15.7M2.2 3H17.8C18.4627 3 19 3.53726 19 4.2V15C19 15.6627 18.4627 16.2 17.8 16.2H2.2C1.53726 16.2 1 15.6627 1 15V4.2C1 3.53726 1.53726 3 2.2 3Z"
        stroke="#228800"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87693 9.57526C7.86421 9.57526 8.66456 8.77491 8.66456 7.78763C8.66456 6.80035 7.86421 6 6.87693 6C5.88964 6 5.08929 6.80035 5.08929 7.78763C5.08929 8.77491 5.88964 9.57526 6.87693 9.57526Z"
        stroke="#228800"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75336 13.0427C9.32631 11.8194 8.17235 11 6.87668 11C5.58101 11 4.42705 11.8194 4 13.0427"
        stroke="#228800"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
